import {
  GET_ROLES_SUCCESS,
  GET_ROLES_ERROR,
  NEW_ROLE_SUCCESS,
  NEW_ROLE_ERROR,
  MODIFY_ROLE_SUCCESS,
  MODIFY_ROLE_ERROR,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
  ASSIGN_ROLE,
  ASSIGN_ROLE_SUCCESS,
  ASSIGN_ROLE_ERROR,
  REMOVE_ASSIGNEE_SUCCESS,
  REMOVE_ASSIGNEE_ERROR,
  SET_CURRENT_ROLE_PERMISSIONS_UI_STATE,
} from "./actionTypes"

const initialState = {
  user: {},
  error: {},
  roles: [],
  current_role_permissions_state: null
}

const roles = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload,
        error: null,
      }

    case GET_ROLES_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case NEW_ROLE_SUCCESS:
      return {
        ...state,
        error: null,
        roles: {...state.roles, data: [...state.roles.data, action.payload.data]}, //Just add a new role to the existing state(roles)
      }

    case NEW_ROLE_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case MODIFY_ROLE_SUCCESS:
      return {
        ...state,
        error: null,
        roles: {
          ...state.roles,
          data: state.roles.data.map(role =>
            role.id.toString() === action.payload.id.toString()
              ? action.payload
              : role
          )
        },
      }

    case MODIFY_ROLE_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    // UNUSED, we're just calling GET roles again in saga
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        error: null,
        roles: state.roles.filter(
          role => role.id.toString() !== action.payload.id.toString()
        ),
      }

    case DELETE_ROLE_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case ASSIGN_ROLE:
      return {
        ...state,
        error: null,
      }

    case ASSIGN_ROLE_SUCCESS:
      return {
        ...state,
        error: null,
      }

    case ASSIGN_ROLE_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case REMOVE_ASSIGNEE_SUCCESS:
      return {
        ...state,
        error: null,
      }

    case REMOVE_ASSIGNEE_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case SET_CURRENT_ROLE_PERMISSIONS_UI_STATE:
      return {
        ...state,
        current_role_permissions_state: action.payload
      }
    default:
      return state
  }
}

export default roles
